"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fireDrillEvent = exports.getDrillIntersection = exports.getIntersectionPartAfter = exports.convertDrillableItemsToPredicates = exports.isSomeHeaderPredicateMatched = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2021 GoodData Corporation
var sdk_backend_spi_1 = require("@gooddata/sdk-backend-spi");
var custom_event_1 = tslib_1.__importDefault(require("custom-event"));
var findIndex_1 = tslib_1.__importDefault(require("lodash/findIndex"));
var HeaderPredicateFactory_1 = require("../headerMatching/HeaderPredicateFactory");
var DrillEvents_1 = require("./DrillEvents");
/**
 * @internal
 */
function isSomeHeaderPredicateMatched(drillablePredicates, header, dv) {
    return drillablePredicates.some(function (drillablePredicate) {
        return drillablePredicate(header, { dv: dv });
    });
}
exports.isSomeHeaderPredicateMatched = isSomeHeaderPredicateMatched;
/**
 * @internal
 */
function convertDrillableItemsToPredicates(drillableItems) {
    return drillableItems.map(function (drillableItem) {
        if (DrillEvents_1.isDrillableItemUri(drillableItem)) {
            return HeaderPredicateFactory_1.uriMatch(drillableItem.uri);
        }
        else if (DrillEvents_1.isDrillableItemIdentifier(drillableItem)) {
            return HeaderPredicateFactory_1.identifierMatch(drillableItem.identifier);
        }
        else {
            return drillableItem;
        }
    });
}
exports.convertDrillableItemsToPredicates = convertDrillableItemsToPredicates;
/**
 * @internal
 */
function getIntersectionPartAfter(intersection, localIdentifier) {
    var index = findIndex_1.default(intersection, function (item) {
        return DrillEvents_1.isDrillIntersectionAttributeItem(item.header) &&
            item.header.attributeHeader.localIdentifier === localIdentifier;
    });
    return intersection.slice(index);
}
exports.getIntersectionPartAfter = getIntersectionPartAfter;
/**
 * @internal
 */
function getDrillIntersection(drillItems) {
    return drillItems.reduce(function (drillIntersection, drillItem, index, drillItems) {
        if (sdk_backend_spi_1.isAttributeDescriptor(drillItem)) {
            var attributeItem = drillItems[index - 1]; // attribute item is always before attribute
            if (attributeItem && sdk_backend_spi_1.isResultAttributeHeader(attributeItem)) {
                drillIntersection.push({
                    header: tslib_1.__assign(tslib_1.__assign({}, attributeItem), drillItem),
                });
            }
            else {
                // no attr. item before attribute -> use only attribute header
                drillIntersection.push({
                    header: drillItem,
                });
            }
        }
        else if (sdk_backend_spi_1.isMeasureDescriptor(drillItem) || sdk_backend_spi_1.isTotalDescriptor(drillItem)) {
            drillIntersection.push({
                header: drillItem,
            });
        }
        return drillIntersection;
    }, []);
}
exports.getDrillIntersection = getDrillIntersection;
/**
 * Fire a new drill event built from the provided data to the target that have a 'dispatchEvent' method.
 *
 * @param drillEventFunction - custom drill event function which could process and prevent default post message event.
 * @param drillEventData - The event data in `{ executionContext, drillContext }` format.
 * @param target - The target where the built event must be dispatched.
 * @internal
 */
function fireDrillEvent(drillEventFunction, drillEventData, target) {
    var shouldDispatchPostMessage = drillEventFunction && drillEventFunction(drillEventData);
    if (shouldDispatchPostMessage !== false) {
        target.dispatchEvent(new custom_event_1.default("drill", {
            detail: drillEventData,
            bubbles: true,
        }));
    }
}
exports.fireDrillEvent = fireDrillEvent;
//# sourceMappingURL=drilling.js.map